import actionConstants from '../constants/ActionConstants';

const initialState = {
  error: '',
  isfetching: false,
  success: '',
  pages: 0,
  searchText: '',
  reportData: []
};

export default function getReportList(state = initialState, action) {
  switch (action.type) {
    case actionConstants.GET_REPORT_LIST_REQUEST:
      return {
        ...state,
        isfetching: true,
        error: '',
        success: '',
      };
    case actionConstants.GET_REPORT_LIST_SUCCESS:

      return {
        ...state,
        reportData: action.payload.page === 1 ? action.payload.docs
          : [...state.reportData, ...action.payload.docs],
        isfetching: false,
        success: action.message,
        pages: action.payload.pages,
      };
    case actionConstants.GET_REPORT_LIST_FAILURE:
      return {
        ...state,
        error: action.message,
        isfetching: false,
        success: '',
      };
    case actionConstants.CLEAR_REPORT_LIST:
      return {
        ...initialState,
      };
    case actionConstants.CLEAR_STATE:
      return {
        ...state,
        error: '',
        success: '',
        isfetching: false,
        deficiencyData: [],
      };
    case actionConstants.RESET_ALL_REDUCERS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}
